import { injectGlobal } from "styled-components";

injectGlobal`
  .lowercase {
    text-transform: lowercase !important;
  }

  .text-align-right {
    text-align: right !important;
  }

  .text-transform-none {
    text-transform: none !important;
    font-weight: 400;
    border: thin solid rgba(0,0,0,0.1) !important;
    height: 4.5rem;
    padding: 8px 16px;
  }

  .text-transform-none-normal {
    text-transform: none !important;
  }
  
  .italic {
    font-style: italic;
  }

  .wrapper {
    display:flex;
    flex-grow: 1;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cursor-normal {
    cursor: initial !important;
  }

  .full {
    width: 100% !important;
  }

  .position-relative {
    position: relative;
  }

  .primary-size {
    font-size: 1.2rem !important;
  }
  
  .secondary-size {
    font-size: 1.6rem !important;
  }

  .grey-paper {
    background-color: #f5f5f5 !important;
  }

  .fs2 {
    font-size: 2rem !important;
    color: rgba(0, 0, 0, 0.54) !important;
  }

  .t1 {
    font-size: 2.2rem;
    padding-bottom: 1rem;
    border-bottom: thin solid #c2cfd6;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
  }

  .t2 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .t3 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }

  .t4 {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    
  }

  .p0 {
    padding: 0 !important;
  }

  .p1 {
    padding: 1rem;
  }
  .p2 {
    padding: 2rem !important;
  }
  .p3 {
    padding: 3rem;
  }
  .p4 {
    padding: 4rem;
  }
  .p5 {
    padding: 5rem;
  }

  .pb1 {
    padding-bottom: 1rem;
  }
  .pb2 {
    padding-bottom: 2rem;
  }
  .pb3 {
    padding-bottom: 3rem;
  }
  .pb4 {
    padding-bottom: 4rem;
  }
  .pb5 {
    padding-bottom: 5rem;
  }

  .pr1 {
    padding-right: 1rem;
  }

  .pr2 {
    padding-right: 2rem;
  }

  .pl1 {
    padding-left: 1rem;
  }

  .pl2 {
    padding-left: 2rem;
  }

  .mrp5 {
    margin-right: .5rem !important;
  }

  .mr1 {
    margin-right: 1rem !important;
  }
  .mr2 {
    margin-right: 2rem !important;
  }
  .mr3 {
    margin-right: 3rem;
  }
  .mr4 {
    margin-right: 4rem;
  }
  .mr5 {
    margin-right: 5rem;
  }

  .ml-auto {
    margin-left: auto !important;
  }

  .ml0 {
    margin-left: 0 !important;
  }

  .ml1 {
    margin-left: 1rem !important;
  }
  .ml2 {
    margin-left: 2rem !important;
  }
  .ml3 {
    margin-left: 3rem !important;
  }
  .ml4 {
    margin-left: 4rem;
  }
  .ml5 {
    margin-left: 5rem;
  }

  .mtp5 {
    margin-top: .5rem;
  }
  .mt0 {
    margin-top: 0 !important;
  }
  .mt1 {
    margin-top: 1rem !important;
  }
  .mt2 {
    margin-top: 2rem !important;
  }
  .mt3 {
    margin-top: 3rem;
  }
  .mt4 {
    margin-top: 4rem;
  }
  .mt5 {
    margin-top: 5rem;
  }

  .mb0 {
    margin-bottom: 0 !important;
  }

  .mbp5 {
    margin-bottom: .5rem !important;
  }

  .mb1 {
    margin-bottom: 1rem !important;
  }
  .mb2 {
    margin-bottom: 2rem !important;
  }
  .mb3 {
    margin-bottom: 3rem;
  }
  .mb4 {
    margin-bottom: 4rem;
  }
  .mb5 {
    margin-bottom: 5rem;
  }

  .align-self-center {
    align-self: center !important;
    margin-bottom: 0 !important;
    margin-top: 1.8rem;
  }

  .align-self-end {
    align-self: flex-end !important;
    margin-bottom: 0 !important;
  }

  .align-items-center {
    align-items: center !important;
  }

  .flex-start {
    justify-content: flex-start !important;
  }

  .flex-auto {
    flex-grow: 0 !important;

    label {
      flex-grow: 0 !important;
    }
  }

  .hide {
    display: none !important;
  }

  .show-all {
    tr {
      display: table-row !important;
    }
  }

  .display-flex {
    display: flex;
  }

  .metade {
    width: 50%;
  }

  .flex-end {
    justify-content: flex-end;
    display: flex;
    flex-grow: 1;
  }

  .font-weight-normal {
    font-weight: normal;
  }

  .ativao {
    color: #ffffff !important;
    background-color: #1ab394;

    .tags-container {
      color: #ffffff !important;

      .green-alert {
        color: #ffffff !important;
      }
    }

    .green-alert {
      color: #ffffff !important;
    }
  }

  .ativao-vermelho {
    color: #ffffff !important;
    background-color: #f86c6b;

    .tags-container {
      color: #ffffff !important;

      .red-alert {
        color: #ffffff !important;
      }
    }

    .red-alert {
      color: #ffffff !important;
    }
  }

  @media print {
    .mb2 {
      margin-bottom: 0 !important;
    }
  
    .mt2 {
      margin-top: 0 !important;
    }
  }
  
  .fontw-600 {
    font-weight: 600;
  }
  
`;



// WEBPACK FOOTER //
// ./src/styles/utils.js